import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FilmServiceService {

  constructor(private http: HttpClient) { }

  getContestFilmDetails() {
    const url = environment.apiURL + `api/all/contests/except-drawings`;
    return this.http.get(url);
  }
  getFansDetails(contestId:any){
    const url = environment.apiURL + `api/contests/${contestId}`;
    return this.http.get(url);

  }
  getDrawing(contestId:any){
    const url = environment.apiURL + `api/drawings/${contestId}`;
    return this.http.get(url);

  }
  getDrawings(){
    const url = environment.apiURL + `api/drawings`;

    return this.http.get(url);
  }

  getPointsHistory(): Observable<any> {
    const url = environment.apiURL + `api/totalCreaticsCurrency`;
    return this.http.get(url);
  }
  getUserId(): Observable<any> {
    const url = environment.apiURL + `cinejoy/api/showcases`;
    return this.http.get(url);
  }
  getDrawingDetails(contestId:any): Observable<any> {
    const url = environment.apiURL + `drawings/${contestId}`;
    return this.http.get(url);
  }
  getPrizes(contestId:any): Observable<any> {
    const url = environment.apiURL + `api/contests/${contestId}/getPrizesInContest`;
    return this.http.get(url);
  }
  postDrawingTicket(contestId:any,noOfTickets:any,paymentType:any,creaticsCurrency:any){
    const url = environment.apiURL + `api/charge/drawing/contest/id/${contestId}`;
     const formData = new FormData();
    formData.append('noOfTickets', noOfTickets);
    formData.append('paymentType', paymentType);
    formData.append('creaticsCurrency', creaticsCurrency);
    return this.http.post(url, formData);

  }

  putVoting(postData:any): Observable<any> {
    const url = environment.apiURL + `api/voteTransaction`;

        return this.http.put(url, postData)
  }

  postUpvote(postDataUpvote:any): Observable<any> {
    const url = environment.apiURL + `api/upvoteContest`;

        return this.http.post(url, postDataUpvote)
  }
  postHitmakerMain(title: any, description: any, file: any) {

  }
}
